(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('evaluation-template-mars-mors', {
                parent: 'entity',
                url: '/evaluation-template-mars-mors',
                data: {
                    authorities: [],
                    pageTitle: 'EvaluationTemplateMarsMors'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation-template-mars-mors/list/evaluation-template-mars-mors.html',
                        controller: 'EvaluationTemplateMarsMorsController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Care & Delivery MARs/MORs'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_EVALUATION_TEMPLATE_MARS_MORS];

                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_EVALUATION_TEMPLATE_MARS_MORS, access);
                }]
            });
    }
})();
